<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div :class="[$style.accountPage,
                { [$style.accountPageMobile]: isMobilePlatform }]">
    <a :class="$style.logoLink"
       href="#" >
      <Logo />
    </a>
    <div :class="$style.accountTitle">
      <h5>My Account</h5>
    </div>


    <div v-if="user"
         :class="$style.mainAccountInfo">
      <v-layout row>
        <v-flex xs12
                md10
                lg6
                offset-xs0
                offset-md1
                offset-lg3>
          <v-layout row
                    wrap>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">First Name*</h6>
                <p :class="$style.accountInfoValue">{{ user.firstName }}</p>
              </div>
            </v-flex>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">Last Name*</h6>
                <p :class="$style.accountInfoValue">{{ user.lastName }}</p>
              </div>
            </v-flex>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">Email*</h6>
                <p :class="$style.accountInfoValue">{{ user.email }}</p>
              </div>
            </v-flex>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">Phone*</h6>
                <p :class="$style.accountInfoValue">{{ user.phone }}</p>
              </div>
            </v-flex>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">Birthday (optional)</h6>
                <p :class="$style.accountInfoValue">{{ user.birthday }}</p>
              </div>
            </v-flex>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6/>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">
                  Mailing Address (optional)
                </h6>
                <p :class="$style.accountInfoValue">
                  {{ fullAddress }}
                </p>
              </div>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout v-if="false"
                row>
        <v-flex offset-md1
                offset-lg3
                md10
                lg6>
          <h6 :class="$style.preferencesTitle">Preferences (optional)</h6>
          <v-layout row
                    wrap>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">Preference Question #1</h6>
                <p :class="$style.accountInfoValue">Tustin</p>
              </div>
            </v-flex>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">Preference Question #2</h6>
                <p :class="$style.accountInfoValue">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nam ultrices nibh lacus, in dictum quam volutpat eget.
                </p>
              </div>
            </v-flex>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">Preference Question #3</h6>
                <p :class="$style.accountInfoValue">
                  Lorem ipsum dolor sit amet
                </p>
              </div>
            </v-flex>

            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <div :class="$style.accountInfoField">
                <h6 :class="$style.acoountInfoTitle">Preference Question #4</h6>
                <p :class="$style.accountInfoValue">
                  Nam ultrices nibh lacus, in dictum quam volutpat eget.
                </p>
              </div>
            </v-flex>

          </v-layout>

        </v-flex>

      </v-layout>

      <v-layout v-if="!isMobilePlatform"
                row>
        <v-flex xs12>
          <BaseButton :button-style="'Main'"
                      :class="$style.accountEditBtn"
                      @click="openEditAccount">
            Edit Account
          </BaseButton>
        </v-flex>
      </v-layout>

      <v-layout justify-center>
        <RemoveAccountButton />
      </v-layout>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton';
import Logo from '@/components/Logo';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import RemoveAccountButton from './RemoveAccountButton';

/**
 * Page to display and edit users account data.
 */
@Component({
  components: {
    BaseButton,
    Logo,
    RemoveAccountButton,
  },
})
export default class UserAccount extends Vue {
  @Getter('authUser') user;
  @Getter isMobilePlatform;

  get fullAddress() {
    if (this.user.address || this.user.city) {
      if (this.user.state || this.user.zip) {
        return `${this.user.address} ${this.user.city}, ${this.user.state} ${this.user.zip}`;
      }

      return `${this.user.address} ${this.user.city}`;
    }

    return `${this.user.state} ${this.user.zip}`;
  }

  openEditAccount() {
    this.$router.push({ path: '/create-account' });
  }
}
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";
  @import "@/style/helpers.scss";

  .accountPage{
    min-height: 100%;
    background-color: $white;
    padding: 40px 0 80px;
  }

  .appGrid {
    position: relative;
    @extend %flex;
  }

  .logoLink {
    display: block;
    text-align: center;
    margin: 0 auto 19px;
    max-width: 169px;
  }

  .accountTitle {
    text-align: center;
    margin-bottom: 26px;
  }

  .accountInfoField {
    margin: 0 0 30px;
  }

  .appGrid:nth-child(odd) .accountInfoField {
    margin-right: 33px;
  }

  .appGrid:nth-child(even) .accountInfoField {
    margin-left: 33px;
  }

  .acoountInfoTitle {
    font-family: 'Gotham', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: $label-green;
    margin-bottom: 10px;
  }

  .accountInfoValue {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: $black;
  }

  .preferencesTitle {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 20px;
  }

  .accountPage .accountEditBtn {
    margin: 0 auto;
    padding: 27px 90px;
    height: auto;
  }

  @media screen and (max-width: 959px) {
    .appGrid:nth-child(odd) .accountInfoField {
      margin-right: 0;
    }

    .appGrid:nth-child(even) .accountInfoField {
      margin-left: 0;
    }
  }

  @media screen and (max-width: $mobile-breakpoint-max) {
    .accountPage {
      background-color: $light-cart-bg;
      padding: 30px 0 63px;
    }

    .logoLink,
    .accountTitle {
      display: none;
    }

    .acoountInfoTitle {
      margin-bottom: 4px;
    }

    .accountInfoValue {
      font-family: 'Gotham', sans-serif;
      font-size: 15px;
      font-weight: 300;
    }

    .accountInfoField {
      margin-bottom: 19px;
      padding: 0 13px;
    }

    .preferencesTitle {
      text-align: left;
      color: $title-black;
      padding: 0 28px;
      text-transform: uppercase;
      opacity: 0.3;
      font-size: 14px;
      margin-top: 30px;
      margin-bottom: 18px;
    }
    .accountPage  .accountEditBtn {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      max-width: 100%;
      padding: 16px 0;
      margin: 0;
      border-radius: 0;
      div {
        font-size: 14px;
        line-height: 14px;
      }
      &:hover,
      &:focus,
      &:active {
        position: fixed;
      }
    }
  }

  .accountPageMobile {
    padding: 30px 0 20px 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/UserAccount.vue